<script setup>
	import Modal from './assets/libraries/ModalHandler';
	window.Modal = Modal;

	// import { NotificationCenter } from './assets/libraries/NotificationHandler'
	// window.NotificationCenter = NotificationCenter
</script>

<template>
	<div id="app" style="min-height: 100vh">
		<!-- <Header v-if="hide_header_for_routes.indexOf($route.path) == -1 && $route?.meta?.prefers_fullscreen != true" /> -->

		<div style="min-height: var(--page-height)">
			<router-view style="min-height: var(--page-height)"></router-view>
		</div>
	</div>

	<div class="notifications_center"></div>
	<div id="general_modals"></div>

	<Toaster theme="dark" :visibleToasts="5" :duration="15000" />

	<link rel="stylesheet" href="https://rsms.me/inter/inter.css" />
	<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
</template>

<script>
	import { getVersionDetails } from '@/services/VersionService.js';
	import { BUILD_NUMBER, BUILD_TYPE, VERSION_NUMBER } from '@/VersionInfo';
	import { useVersionStore } from '@/stores/version';
	import { useSettingStore } from '@/stores/setting';
	import moment from 'moment';
	import { initDesktopAgentConnection } from '@/assets/libraries/DesktopAgentWebsocketConnection';
	import { Toaster } from 'vue-sonner';
	import { useAuthStore } from '@/stores/auth';

	export default {
		components: { Toaster },
		data() {
			return {
				setting_store: useSettingStore(),
			};
		},
		methods: {
			async fetchVersionDetails() {
				try {
					const response = await getVersionDetails(BUILD_TYPE);
					if (response?.error !== undefined) {
						throw new Error(JSON.stringify(response.error));
					} else {
						const version_store = useVersionStore();
						version_store.setLatestReleaseInformation(response);
						let current_version = response.version_number;
						let current_build_number = response.build_number;
						if (current_version != VERSION_NUMBER || current_build_number != BUILD_NUMBER) {
							//Try to force an update
							let tried_to_update = localStorage.getItem('tried_to_update_to');

							if (tried_to_update != undefined) {
								if (tried_to_update === `${current_version}.${current_build_number}`) {
									const tried_to_update_on = localStorage.getItem('tried_to_update_date');
									if (tried_to_update_on != null) {
										//Check if it has been 2 days since the last time it tried to update
										if (moment().diff(moment(tried_to_update_on), 'days', true) >= 2) {
											tried_to_update = false;
										}
									}
								} else {
									//Try to update because it is a diffrent version or build number
									tried_to_update = false;
								}
							}
							if (tried_to_update == undefined || tried_to_update == false) {
								localStorage.setItem('tried_to_update_to', `${current_version}.${current_build_number}`);
								localStorage.setItem('tried_to_update_date', new Date().toUTCString());

								location.reload(true);
							} else {
								version_store.setOutOfDate(true);
							}
						}
					}
				} catch (error) {
					console.log('🚀 ~ file: App.vue:68 ~ fetchVersionDetails ~ error:', error);
				}
			},

			createElevateStudioUserActionsBroadcastChannel: function () {
				const setting_store = useSettingStore();
				try {
					if (BroadcastChannel != undefined) {
						setting_store.elevate_studio_user_actions_broadcast_channel = new BroadcastChannel('csc_user_actions_broadcast_channel');
					}
				} catch (error) {
					console.error('Error creating broadcast channel', error);
				}
			},
		},
		async mounted() {
			this.fetchVersionDetails(); // from api
			this.createElevateStudioUserActionsBroadcastChannel();

			if (navigator.storage && navigator.storage.persist) {
				navigator.storage.persist().then((persistent) => {
					if (persistent) {
						console.log('Storage will not be cleared except by the user');
					} else {
						console.log('Storage may be cleared by the UA under storage pressure.');
					}
				});
			}

			// Skip Desktop Agent initialization during testing
			if (import.meta.env.MODE !== 'test' && !window.Cypress) {
				try {
					initDesktopAgentConnection();
				} catch (error) {
					console.log('[Desktop Agent] Error during desktop agent init', error);
				}
			}

			try {
				const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID;
				if (CLARITY_PROJECT_ID != undefined && CLARITY_PROJECT_ID?.trim?.() != '') {
					this.Clarity.init(CLARITY_PROJECT_ID);

					setTimeout(() => {
						const auth_store = useAuthStore();
						if (window.clarity != undefined && auth_store?.user_info?.UUID != undefined) {
							this.Clarity.identify(auth_store.user_info.UUID);
						}
					}, 1000);
				}
			} catch (error) {
				console.log('[Clarity] Error initializing', error);
			}
		},
		watch: {
			'setting_store.settings.scroll_bar_visibility': {
				handler(newValue) {
					if (newValue) {
						// Remove existing scrollbar classes
						document.body.className = document.body.className.replace(/scrollbar-\w+/g, '');
						// Add new class
						const className = `scrollbar-${newValue.toLowerCase().replace('_', '-')}`; // AUTO, ALWAYS_VISABLE, HIDDEN
						document.body.classList.add(className);
					}
				},
				immediate: true,
			},
		},
	};
</script>

<style>
	@import '@/assets/css/Modal.css';
	@import '@/assets/css/Notifications.css';
	:root {
		--header-height: 0px;
		--page-height: calc(100vh - var(--header-height));
	}
</style>
